var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSerceFinansowLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 407.79 164.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-4);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 68,
    y1: 0,
    x2: 68,
    y2: 164.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1782b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#e0ac47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1782b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 238.57,
    y1: 38.17,
    x2: 238.57,
    y2: 76.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf8e33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#e0ac47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bf8e33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 179.29,
    y1: 92.28,
    x2: 179.29,
    y2: 129.17,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 201.98,
    y1: 90.89,
    x2: 201.98,
    y2: 98.46,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 201.98,
    y1: 101.76,
    x2: 201.98,
    y2: 129.17,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 226.13,
    y1: 101.25,
    x2: 226.13,
    y2: 129.17,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 257.74,
    y1: 101.25,
    x2: 257.74,
    y2: 129.68,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 289.28,
    y1: 101.25,
    x2: 289.28,
    y2: 129.17,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 320.05,
    y1: 101.25,
    x2: 320.05,
    y2: 129.68,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 351.41,
    y1: 101.25,
    x2: 351.41,
    y2: 129.68,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 354.47,
    y1: 90.25,
    x2: 354.47,
    y2: 98.11,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 388.52,
    y1: 101.76,
    x2: 388.52,
    y2: 129.17,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m136,61.22v-17.81L68,0,0,43.41v17.81c0,8.71,1.12,17.3,3.26,25.64.26,1.36.63,2.7,1.12,4.03,8.82,29.37,30.58,55.43,61.82,72.83l1.79,1,1.79-1c30.65-17.07,52.17-42.47,61.3-71.15,1.07-2.34,1.74-4.8,2.03-7.27,1.89-7.85,2.87-15.91,2.87-24.08ZM7.35,47.44L68,8.72l60.65,38.72v13.78c0,2.14-.08,4.27-.22,6.39-.71-.95-1.49-1.87-2.35-2.72-6.12-6.12-14.26-9.49-22.91-9.49-2.3,0-4.57.24-6.77.71v-12.25l-28.4-18.13-28.4,18.13v12.27c-10.38-2.2-21.63.72-29.68,8.76-.86.86-1.64,1.77-2.35,2.73-.14-2.12-.22-4.25-.22-6.39v-13.78Zm81.7,11.17c-3.22,1.56-6.18,3.66-8.79,6.27l-12.26,12.26-12.26-12.26c-2.63-2.63-5.61-4.71-8.79-6.25v-10.75l21.05-13.44,21.05,13.44v10.74Zm-21.05,97.67c-29.81-17.14-50.15-42.6-57.55-71.01-.98-5.53.7-11.22,4.67-15.19,9.77-9.77,25.66-9.77,35.42,0l17.46,17.46,17.46-17.46c4.73-4.73,11.02-7.34,17.71-7.34,6.69,0,12.98,2.61,17.71,7.34,3.71,3.71,5.47,8.85,5,13.9-7.11,28.93-27.62,54.91-57.88,72.31Zm0-104.92c2.3,0,4.16,1.86,4.16,4.16s-1.86,4.16-4.16,4.16-4.16-1.86-4.16-4.16,1.86-4.16,4.16-4.16Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m188.42,65.89c0-1.44-.53-2.54-1.6-3.31-1.07-.77-2.99-1.58-5.76-2.43-2.77-.85-4.97-1.69-6.59-2.52-4.41-2.26-6.61-5.31-6.61-9.15,0-1.99.59-3.77,1.77-5.33,1.18-1.56,2.88-2.78,5.09-3.66,2.21-.88,4.7-1.32,7.45-1.32s5.25.48,7.42,1.43c2.17.95,3.85,2.3,5.05,4.04s1.8,3.72,1.8,5.93h-8c0-1.69-.56-3-1.68-3.94-1.12-.94-2.69-1.41-4.72-1.41s-3.48.39-4.56,1.18c-1.08.79-1.63,1.82-1.63,3.1,0,1.2.64,2.2,1.91,3.02s3.14,1.57,5.61,2.28c4.55,1.3,7.87,2.91,9.95,4.84,2.08,1.93,3.12,4.32,3.12,7.2,0,3.19-1.27,5.7-3.81,7.51-2.54,1.82-5.97,2.72-10.27,2.72-2.99,0-5.71-.52-8.16-1.56-2.45-1.04-4.33-2.46-5.61-4.27-1.29-1.81-1.93-3.9-1.93-6.28h8.03c0,4.07,2.56,6.11,7.68,6.11,1.9,0,3.39-.37,4.45-1.1,1.07-.74,1.6-1.76,1.6-3.08Zm27.86,10.19c-4.23,0-7.68-1.23-10.34-3.7-2.66-2.47-3.99-5.75-3.99-9.86v-.71c0-2.75.56-5.22,1.68-7.39,1.12-2.17,2.71-3.84,4.76-5.02,2.05-1.17,4.4-1.76,7.03-1.76,3.95,0,7.05,1.18,9.32,3.55,2.27,2.37,3.4,5.72,3.4,10.06v2.99h-18.38c.25,1.79,1,3.23,2.25,4.31,1.25,1.08,2.84,1.62,4.76,1.62,2.97,0,5.29-1.02,6.96-3.07l3.79,4.03c-1.16,1.55-2.72,2.77-4.69,3.64s-4.16,1.3-6.56,1.3Zm-.88-22.53c-1.53,0-2.77.49-3.72,1.48-.95.98-1.56,2.39-1.83,4.22h10.72v-.59c-.04-1.63-.5-2.89-1.39-3.78-.89-.89-2.15-1.34-3.79-1.34Zm34.98,1.47c-1.05-.14-1.97-.2-2.77-.2-2.92,0-4.83.94-5.73,2.81v17.94h-7.71v-27.42h7.28l.21,3.27c1.55-2.52,3.69-3.78,6.43-3.78.85,0,1.65.11,2.4.33l-.11,7.04Zm16.84,15.15c1.42,0,2.58-.37,3.47-1.11.89-.74,1.35-1.73,1.39-2.96h7.23c-.02,1.86-.55,3.56-1.6,5.11-1.05,1.55-2.49,2.75-4.31,3.6-1.82.85-3.84,1.28-6.04,1.28-4.13,0-7.38-1.25-9.76-3.74-2.38-2.49-3.57-5.93-3.57-10.33v-.48c0-4.22,1.18-7.59,3.55-10.11,2.36-2.52,5.61-3.78,9.74-3.78,3.61,0,6.5.98,8.68,2.93,2.18,1.95,3.28,4.55,3.32,7.79h-7.23c-.04-1.43-.5-2.59-1.39-3.48-.89-.89-2.06-1.34-3.52-1.34-1.8,0-3.15.62-4.07,1.86-.92,1.24-1.37,3.26-1.37,6.05v.76c0,2.83.45,4.86,1.36,6.09.91,1.24,2.28,1.85,4.13,1.85Zm31.4,5.9c-4.23,0-7.68-1.23-10.34-3.7-2.66-2.47-3.99-5.75-3.99-9.86v-.71c0-2.75.56-5.22,1.68-7.39,1.12-2.17,2.71-3.84,4.76-5.02,2.05-1.17,4.4-1.76,7.03-1.76,3.95,0,7.05,1.18,9.32,3.55,2.27,2.37,3.4,5.72,3.4,10.06v2.99h-18.38c.25,1.79,1,3.23,2.25,4.31,1.25,1.08,2.84,1.62,4.76,1.62,2.97,0,5.29-1.02,6.96-3.07l3.79,4.03c-1.16,1.55-2.72,2.77-4.69,3.64-1.97.87-4.16,1.3-6.56,1.3Zm-.88-22.53c-1.53,0-2.77.49-3.72,1.48-.95.98-1.56,2.39-1.83,4.22h10.72v-.59c-.04-1.63-.5-2.89-1.39-3.78s-2.15-1.34-3.79-1.34Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "190.02 114.1 174.65 114.1 174.65 129.17 166.65 129.17 166.65 92.28 191.94 92.28 191.94 98.44 174.65 98.44 174.65 107.96 190.02 107.96 190.02 114.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m197.66,94.66c0-1.1.39-2,1.16-2.71s1.83-1.06,3.16-1.06,2.36.36,3.15,1.06c.78.71,1.17,1.61,1.17,2.71s-.4,2.03-1.19,2.74c-.79.71-1.84,1.06-3.13,1.06s-2.34-.35-3.13-1.06c-.79-.71-1.19-1.62-1.19-2.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 198.11,
    y: 101.76,
    width: 7.74,
    height: 27.42
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m220.93,101.76l.24,3.17c2.06-2.45,4.83-3.67,8.29-3.67,3.06,0,5.33.85,6.83,2.56,1.49,1.71,2.26,4.26,2.29,7.65v17.71h-7.71v-17.53c0-1.55-.36-2.68-1.07-3.38-.71-.7-1.89-1.05-3.55-1.05-2.17,0-3.8.88-4.88,2.64v19.33h-7.71v-27.42h7.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m269.43,122.83v-11.88c0-3.07-1.05-5.46-3.14-7.16-2.09-1.7-4.91-2.54-8.47-2.54-2.34,0-4.46.38-6.34,1.15-1.89.77-3.35,1.83-4.38,3.18-1.03,1.35-1.55,2.82-1.55,4.41h7.71c0-1.03.37-1.84,1.11-2.44.74-.59,1.76-.88,3.05-.88,1.48,0,2.56.38,3.24,1.14.69.76,1.03,1.77,1.03,3.04v1.57h-3.55c-4.28.02-7.56.8-9.82,2.36-2.27,1.55-3.41,3.78-3.41,6.69,0,2.36.93,4.32,2.79,5.87,1.86,1.56,4.2,2.34,7.03,2.34,2.99,0,5.41-.99,7.28-2.97.16.98.42,1.8.77,2.46h7.79v-.43c-.74-1.34-1.13-3.3-1.14-5.91Zm-7.74-1.42c-.46.82-1.17,1.46-2.13,1.94-.96.49-2.01.73-3.15.73s-2.1-.3-2.77-.89c-.68-.59-1.02-1.34-1.02-2.26l.03-.43c.25-2.53,2.3-3.8,6.16-3.8h2.88v4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m284.08,101.76l.24,3.17c2.06-2.45,4.83-3.67,8.29-3.67,3.06,0,5.33.85,6.83,2.56,1.49,1.71,2.26,4.26,2.29,7.65v17.71h-7.71v-17.53c0-1.55-.36-2.68-1.07-3.38-.71-.7-1.89-1.05-3.55-1.05-2.17,0-3.8.88-4.88,2.64v19.33h-7.71v-27.42h7.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m324.85,121.6c0-.89-.47-1.6-1.4-2.12-.93-.51-2.43-.98-4.49-1.38-6.86-1.37-10.3-4.14-10.3-8.31,0-2.43,1.06-4.46,3.19-6.09,2.12-1.63,4.9-2.45,8.33-2.45,3.66,0,6.59.82,8.79,2.46,2.2,1.64,3.29,3.77,3.29,6.39h-7.71c0-1.05-.36-1.91-1.07-2.6-.71-.68-1.82-1.03-3.33-1.03-1.3,0-2.3.28-3.01.84s-1.07,1.27-1.07,2.13c0,.81.4,1.47,1.21,1.96.81.5,2.17.93,4.09,1.29s3.54.77,4.85,1.23c4.07,1.42,6.11,3.88,6.11,7.37,0,2.5-1.13,4.52-3.39,6.07-2.26,1.55-5.17,2.32-8.75,2.32-2.42,0-4.57-.41-6.44-1.23-1.88-.82-3.35-1.94-4.41-3.37-1.07-1.43-1.6-2.97-1.6-4.62h7.31c.07,1.3.58,2.3,1.52,2.99.94.69,2.2,1.04,3.79,1.04,1.48,0,2.59-.27,3.35-.8.76-.53,1.13-1.23,1.13-2.09Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m365.03,113.86c-.29-3.88-1.66-6.96-4.12-9.22-2.47-2.26-5.65-3.39-9.54-3.39-2.74,0-5.14.58-7.21,1.74-2.08,1.17-3.66,2.82-4.77,4.94-1.1,2.13-1.65,4.56-1.65,7.28v.33c0,4.36,1.24,7.8,3.72,10.33,2.48,2.54,5.8,3.81,9.96,3.81s7.48-1.28,9.95-3.82c2.47-2.54,3.71-5.91,3.71-10.12l-.05-1.88Zm-9.23,7.87c-1.05,1.36-2.51,2.04-4.38,2.04s-3.39-.69-4.42-2.07c-1.04-1.38-1.55-3.37-1.55-5.97,0-2.93.51-5.09,1.55-6.49,1.03-1.39,2.49-2.09,4.37-2.09s3.38.7,4.43,2.11c1.05,1.4,1.57,3.38,1.57,5.93,0,3-.52,5.18-1.57,6.54Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "352.89 90.25 361.29 90.25 353.91 98.11 347.64 98.11 352.89 90.25"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "396.57 119.21 400.35 101.76 407.79 101.76 400.43 129.17 393.98 129.17 388.51 111.92 383.04 129.17 376.61 129.17 369.25 101.76 376.7 101.76 380.46 119.19 385.74 101.76 391.31 101.76 396.57 119.21"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerceFinansowLogo);
export default __webpack_public_path__ + "static/media/serce-finansow-logo.ec1628b2dca0a1990a3fbc8f3b482397.svg";
export { ForwardRef as ReactComponent };